export class RoleConstants {
  public static readonly Admin = 'Admin';
  public static readonly Clerk = 'Clerk';
  public static readonly Examiner = 'Examiner';
  public static readonly TenantAdmin = 'TenantAdmin';
}
